import type { Store } from "@highmarch/app";
import { isNativeShell } from "../platform/shell";
import { SandboxStorage, SandboxStore } from "./sandboxStore";
import { StoreKitStore } from "./storeKitStore";

/**
 * The game's `Store`, chosen by shell (FINISH_PLAN D9): StoreKit 2 in the iOS app. The browser has no real store: the
 * sandbox store (free test purchases) exists only in dev builds and with `?debug` (or `?sandboxstore`), since the web
 * build is played too and must not hand out gems for nothing (RC1 P1-2). Elsewhere there is none (null): the Shop
 * says gem packs come with the iOS app, and gems earned by playing work as ever.
 * The Shop (WP5) calls `gameStore()`; the grant-once-then-finish loop over it is WP1's (app `Store` rules).
 */
let store: Store | null | undefined;
export function gameStore(): Store | null {
  if (store === undefined) store = isNativeShell() ? new StoreKitStore() : sandboxAllowed() ? new SandboxStore(sandboxStorage()) : null;
  return store;
}

/** Test purchases on the web: dev builds, and a release page opened with `?debug` or `?sandboxstore`. */
export function sandboxAllowed(search: string = globalThis.location?.search ?? "", dev: boolean = import.meta.env.DEV): boolean {
  if (dev) return true;
  const q = new URLSearchParams(search);
  return q.has("debug") || q.has("sandboxstore");
}

/** The sandbox store when this build uses it (the web build with `?debug`), for the debug panel; null otherwise. */
export function sandboxStore(): SandboxStore | null {
  const s = gameStore();
  return s instanceof SandboxStore ? s : null;
}

function sandboxStorage(): SandboxStorage | null {
  try { return globalThis.localStorage ?? null; } catch { return null; }
}
